// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ayfibeoykxjctxirwvbj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF5ZmliZW95a3hqY3R4aXJ3dmJqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI3MDM0MjAsImV4cCI6MjA2ODI3OTQyMH0.rZfOgsl4vPjvugTe_TuP91lt9Q0Ht6mQVsJtwL6jBdc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});